var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"employee-summary-compliance",class:_vm.classes},[_c('img',{staticClass:"employee-summary-compliance__icon",attrs:{"src":_vm.iconName}}),_c('div',{staticClass:"employee-summary-compliance__status"},[_vm._v(_vm._s(_vm.complianceStatus))])])
}
var staticRenderFns = []

export { render, staticRenderFns }